import { render, staticRenderFns } from "./CountStock.vue?vue&type=template&id=0132d9d6&scoped=true&"
import script from "./CountStock.vue?vue&type=script&lang=js&"
export * from "./CountStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0132d9d6",
  null
  
)

export default component.exports